import env from './.env';
import { environment as defaultEnv } from './base.environment';
import { API_ENDPOINT, HeaderKey } from '../config/api-endpoints';
import { updateHeaders } from '../config/update-headers';

let environment = {
  ...defaultEnv,
  metrics: false,
  notifyError: false,
  version: env.version + '-development',
  tier: 'develop',
  nestServerUrl: 'https://api.dev-cjx.tdtech.app',
  serverUrl: 'https://api.dev-cjx.tdtech.app',
  cookies: {
    ...defaultEnv.cookies,
    domain: env.forceDomain || 'posmgr.dev-cjx.tdtech.app'
  },
  imgUrl: 'https://cdn.dev-cjx.tdtech.app/pim-images',
  unleashUrl: 'https://unleash.dev-cjx.tdtech.app/api/frontend/',
  unleashClientKey: '*:development.536927169470069506a60af8a2c9967fb466026da7268e9e706c7d1d',
  unleashAppName: 'cjx-pos-manager',
  unleashEnvironment: 'development',
  unleashCustomHeaders: { 'UNLEASH-SDK': 'unleash-posmanager-sdk:3.10.0' },
  unleashRefreshInterval: 60
};

export const X_HOST_HEADER = {
  [HeaderKey.Authorization]: {
    // Authorization: 'Basic QURNSU5fUE9SVEFMOlBAc3N3MHJk', // For NEST APP
    Authorization: 'Basic Q0pYX1BPU19NQU5BR0VSX0FQUEw6UEBzc3cwcmQ=',
    // Authorization: 'Basic UE9TX0FQUEw6UEBzc3cwcmQ=', // For POS MANAGER APP
    // 'x-host': 'oauth.api.tdshop.io'
    'x-host': 'oauth.api.tdtech.app'
  },
  [HeaderKey.PosApiWithTenant]: {
    'x-host': 'pos.api.tdtech.app',
    'x-tenant-id': 'pos.api.tdtech.app'
  },
  [HeaderKey.IdentityApi]: {
    'x-host': 'identity.api.tdtech.app'
  }
};

environment.services = updateHeaders(API_ENDPOINT, X_HOST_HEADER);

export { environment };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
